module.exports = __webpack_public_path__ + "static/media/timer-backing.67be7066.png";